import Input from "./ui/Input";
import styled from "@emotion/styled";
import { Card } from "@lightspeed/flame/Card";
import CategoryBarItem from "./ui/CategoryBarItem";
import { useDispatch, useSelector } from "react-redux";
import {
  getFloors,
  getItemizers,
  getCategoryItemizers,
  getCategories,
  getPayments,
  getTaxes,
  getCardTypes,
  getCardTypes2,
  getCardTypes3,
  getHouseAccounts,
} from "../redux/slices/companiesSlice";
import { setSearchQuery, uiSelector } from "../redux/slices/uiSlice";
import { authSelector } from "../redux/slices/authSlice";
import {
  getItemizerCodesForToken,
  getItemizerRoute,
  isSpecialItemizerLogin,
} from "../utils/itemizerRules";

const Wrapper = styled.div`
  margin-bottom: 16px;
`;

const InputWrapper = styled.div`
  padding: 6px;
  max-width: 380px;
`;

const Flexed = styled.div`
  display: flex;
`;

const CategoryList = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  padding: 0 32px;
`;

const CategoryBar = () => {
  const dispatch = useDispatch();
  const { searchQuery } = useSelector(uiSelector);
  const { token } = useSelector(authSelector);
  const showPaymentsCrossPosting = isSpecialItemizerLogin({ token });
  const itemizerCodes = getItemizerCodesForToken({ token });
  const showSpecialItemizerTabs = itemizerCodes.length > 0;

  const itemizerTabs = showSpecialItemizerTabs
    ? itemizerCodes.map((code, index) => ({
        id: code,
        url: getItemizerRoute(code, index),
        label: `Itemizers (${code})`,
        itemizer: code,
      }))
    : [{ id: 12346, url: "/details/itemizers", label: "Itemizers" }];

  const tableSelect = [
    { id: 12345, url: "/details", label: "Revenue center" },
    ...itemizerTabs,
    { id: 12347, url: "/details/category", label: "Category" },
    { id: 12348, url: "/details/payments", label: "Payments" },
    ...(showPaymentsCrossPosting
      ? [
          {
            id: 12353,
            url: "/details/payments-cross-posting",
            label: "Payments (Cross posting)",
          },
        ]
      : []),
    { id: 12349, url: "/details/tax", label: "Tax" },
    { id: 12350, url: "/details/other", label: "Other" },
    { id: 12351, url: "/details/reports", label: "Reports" },
    { id: 12352, url: "/details/log", label: "Log" },
  ];

  const getTheFloors = () => dispatch(getFloors());
  const getTheItemizers = (itemizerName) =>
    dispatch(getItemizers(itemizerName ? { Itemizer: itemizerName } : undefined));
  const getTheCategories = () => {
    dispatch(getCategories());
    dispatch(getCategoryItemizers());
  };
  const getThePayments = (paymentData) => {
    dispatch(getCardTypes());
    dispatch(getCardTypes2());
    dispatch(getCardTypes3());
    dispatch(getHouseAccounts());
    dispatch(getPayments(paymentData));
  };
  const getTheTaxes = () => dispatch(getTaxes());

  const itemizerActions = itemizerTabs.reduce(
    (actions, tab) => ({
      ...actions,
      [tab.url]: () => getTheItemizers(tab.itemizer),
    }),
    {}
  );

  const actionByUrl = {
    "/details": getTheFloors,
    ...itemizerActions,
    "/details/category": getTheCategories,
    "/details/payments": () => getThePayments(),
    "/details/payments-cross-posting": () =>
      getThePayments({ operation_id: "crossposting" }),
    "/details/tax": getTheTaxes,
  };

  return (
    <Wrapper>
      <Card>
        <Flexed>
          <CategoryList>
            {tableSelect.map((item) => (
              <CategoryBarItem
                {...item}
                key={item.url}
                onClick={actionByUrl[item.url] || (() => {})}
              />
            ))}
          </CategoryList>
          <InputWrapper>
            <Input
              value={searchQuery}
              valueSet={(e) => dispatch(setSearchQuery(e))}
              placeholder="Search data..."
            />
          </InputWrapper>
        </Flexed>
      </Card>
    </Wrapper>
  );
};

export default CategoryBar;
